import { services } from '../services';
var action = "itemtransaction";

export const itemtransactionService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    approveIn,
    approveOutReceiveIn,
    pay,
    invoice
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function approveIn(id) {
    return services.restApi(`${action}/approvin-in/${id}`, 'GET');
}

function approveOutReceiveIn(id) {
    return services.restApi(`${action}/approvinout-receivein/${id}`, 'GET');
}

function pay(id) {
    return services.restApi(`${action}/pay/${id}`, 'GET');
}

function invoice(id) {
    return services.restApi(`${action}/invoice/${id}`, 'GET');
}